export type BackgroundThemeType =
  | 'original'
  | 'snow'
  | 'midnight'
  | 'sage'
  | 'sea'
  | 'blush'
  | 'sand'
  | 'lavender'
  | 'dawn'
  | 'forest'
  | 'cotton'
  | 'coral';

export interface BackgroundTheme {
  id: BackgroundThemeType;
  name: string;
  emoji: string;
  gradient: string;
  pattern: string;
  patternSize: string;
  textColor: string;
  cardColor: string;
  themeClass: string;
}

export const BACKGROUND_THEMES: BackgroundTheme[] = [
  {
    id: 'original',
    name: 'Original Calmi',
    emoji: '💙',
    gradient: 'linear-gradient(135deg, #C4B5FD 0%, #93C5FD 100%)',
    pattern: 'radial-gradient(circle, transparent 0%, transparent 100%)',
    patternSize: '100% 100%',
    textColor: 'text-slate-900',
    cardColor: 'bg-white/92',
    themeClass: 'calmi-original'
  },
  {
    id: 'snow',
    name: 'Nieve',
    emoji: '❄️',
    gradient: 'linear-gradient(135deg, #FAFAFA 0%, #EFF6FF 100%)',
    pattern: 'radial-gradient(circle, rgba(59, 130, 246, 0.05) 1.5px, transparent 2px)',
    patternSize: '32px 32px',
    textColor: 'text-slate-900',
    cardColor: 'bg-white/92',
    themeClass: 'calmi-snow'
  },
  {
    id: 'midnight',
    name: 'Medianoche',
    emoji: '🌙',
    gradient: 'linear-gradient(180deg, #1E1B4B 0%, #312E81 100%)',
    pattern: 'radial-gradient(circle, transparent 0%, transparent 100%)',
    patternSize: '100% 100%',
    textColor: 'text-slate-100',
    cardColor: 'bg-slate-900/80 text-slate-100',
    themeClass: 'calmi-midnight'
  },
  {
    id: 'sage',
    name: 'Salvia',
    emoji: '🌿',
    gradient: 'linear-gradient(90deg, #D4DFCB 0%, #A8C0A0 100%)',
    pattern: 'radial-gradient(circle, transparent 0%, transparent 100%)',
    patternSize: '100% 100%',
    textColor: 'text-slate-900',
    cardColor: 'bg-white/92',
    themeClass: 'calmi-sage'
  },
  {
    id: 'sea',
    name: 'Mar',
    emoji: '🌊',
    gradient: 'linear-gradient(135deg, #A7F3D0 0%, #67C3E0 100%)',
    pattern: 'radial-gradient(circle, transparent 0%, transparent 100%)',
    patternSize: '100% 100%',
    textColor: 'text-slate-900',
    cardColor: 'bg-white/92',
    themeClass: 'calmi-sea'
  },
  {
    id: 'blush',
    name: 'Rosa pálido',
    emoji: '🌸',
    gradient: 'linear-gradient(135deg, #FBCFE8 0%, #FDE2E4 100%)',
    pattern: 'radial-gradient(circle, transparent 0%, transparent 100%)',
    patternSize: '100% 100%',
    textColor: 'text-slate-900',
    cardColor: 'bg-white/92',
    themeClass: 'calmi-blush'
  },
  {
    id: 'sand',
    name: 'Arena',
    emoji: '🏖️',
    gradient: 'linear-gradient(135deg, #F5E6D3 0%, #E8D4B8 100%)',
    pattern: 'radial-gradient(circle, rgba(120, 80, 40, 0.03) 1px, transparent 1.5px)',
    patternSize: '18px 18px',
    textColor: 'text-stone-900',
    cardColor: 'bg-white/92',
    themeClass: 'calmi-sand'
  },
  {
    id: 'lavender',
    name: 'Lavanda',
    emoji: '💜',
    gradient: 'linear-gradient(135deg, #E9D5FF 0%, #C4B5FD 100%)',
    pattern: 'radial-gradient(circle, transparent 0%, transparent 100%)',
    patternSize: '100% 100%',
    textColor: 'text-slate-900',
    cardColor: 'bg-white/92',
    themeClass: 'calmi-lavender'
  },
  {
    id: 'dawn',
    name: 'Cielo al amanecer',
    emoji: '🌅',
    gradient: 'linear-gradient(135deg, #FED7AA 0%, #FEF3C7 50%, #FBCFE8 100%)',
    pattern: 'radial-gradient(circle, transparent 0%, transparent 100%)',
    patternSize: '100% 100%',
    textColor: 'text-slate-900',
    cardColor: 'bg-white/92',
    themeClass: 'calmi-dawn'
  },
  {
    id: 'forest',
    name: 'Bosque suave',
    emoji: '🌲',
    gradient: 'linear-gradient(180deg, #D1FAE5 0%, #86A789 100%)',
    pattern: 'radial-gradient(circle, transparent 0%, transparent 100%)',
    patternSize: '100% 100%',
    textColor: 'text-slate-900',
    cardColor: 'bg-white/92',
    themeClass: 'calmi-forest'
  },
  {
    id: 'cotton',
    name: 'Algodón',
    emoji: '☁️',
    gradient: 'linear-gradient(135deg, #F3F4F6 0%, #F8FAFC 100%)',
    pattern: 'radial-gradient(circle at 25% 30%, rgba(221, 214, 254, 0.25) 0%, transparent 40%), radial-gradient(circle at 75% 60%, rgba(191, 219, 254, 0.2) 0%, transparent 35%), radial-gradient(circle at 50% 80%, rgba(251, 207, 232, 0.2) 0%, transparent 35%)',
    patternSize: '100% 100%',
    textColor: 'text-slate-900',
    cardColor: 'bg-white/92',
    themeClass: 'calmi-cotton'
  },
  {
    id: 'coral',
    name: 'Coral',
    emoji: '🪸',
    gradient: 'linear-gradient(90deg, #FCA5A5 0%, #FED7AA 100%)',
    pattern: 'radial-gradient(circle, transparent 0%, transparent 100%)',
    patternSize: '100% 100%',
    textColor: 'text-slate-900',
    cardColor: 'bg-white/92',
    themeClass: 'calmi-coral'
  }
];

export const DEFAULT_BACKGROUND_THEME: BackgroundThemeType = 'original';
